module.exports = __webpack_public_path__ + "static/img/logo.c63b914.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 7Otq
// module chunks = 15